import { createContext, useContext } from 'react';

/**
 * The signed-in platform admin and their permissions (from /api/platform/me).
 * Gating here is convenience only: every route is guarded on the server by the
 * same permission keys (lib/platform/permissions.js).
 */
export const allowed = (permissions, needed) => !needed || (permissions || []).includes('*') || (permissions || []).includes(needed);

export const PlatformAdminContext = createContext({ email: null, permissions: [] });

export const usePlatformAdmin = () => useContext(PlatformAdminContext);

/** True when the signed-in admin holds `permission` (or all permissions). */
export function usePlatformCan(permission) {
  return allowed(usePlatformAdmin().permissions, permission);
}
